import { envConfig } from "@configs/env";
import { CountryComponents, DeployCountry } from "@types";
import { getCountryComponent } from "@utils/countries";

const countryComponents: CountryComponents = {
  [DeployCountry.PH]: () => import("./components/PHPersonalInfoPage"),
  [DeployCountry.TH]: () => import("./components/THPersonalInfoPage"),
};

const WrappedPersonalInfoPage = getCountryComponent(countryComponents, envConfig.countryCode);

export default WrappedPersonalInfoPage;
